module.exports = __webpack_public_path__ + "assets/img/12_144.eeb6234a.jpg";